<template>
    <div>
        <checker-detail-row
            v-for="(label, option) in { hourly: 'Hourly', daily: 'Daily', monthly: 'Monthly' }"
            v-if="space.price_matrix[option]"
            :key="option"
        >
            <div slot="left">{{ label }} Price</div>
            <div slot="right">&pound;{{ space.price_matrix[option] | currencyFormat }}</div>
        </checker-detail-row>
    </div>
</template>

<script>
    import CheckerDetailRow from './CheckerDetailRow';

    export default {
        name: 'space-pricing',

        components: { CheckerDetailRow },

        props: {
            space: {
                type: Object,
                default() {
                    return {};
                },
            },
        },
    };
</script>
